import { useDeleteLocation } from '@hakimo-ui/hakimo/data-access';
import { BasicPanel } from '@hakimo-ui/hakimo/ui-elements';
import { toast } from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DeleteLocationModal } from './DeleteLocationModal';

interface Props {
  locationId: number;
  tenantId: string;
}

export function DeleteLocationCard(props: Props) {
  const { locationId, tenantId } = props;
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const onDeleteSuccess = () => {
    toast('Location deleted successfully', { type: 'success' });
    setShowModal(false);
    navigate(`/tenants-admin/${tenantId}`);
  };

  const onDeleteError = (error: Error) => {
    toast(error.message || 'Failed to disable location', { type: 'error' });
  };

  const deleteMutation = useDeleteLocation(
    tenantId,
    locationId,
    onDeleteSuccess,
    onDeleteError
  );

  const handleDelete = () => {
    deleteMutation.mutate();
  };

  return (
    <>
      <BasicPanel title="Delete">
        <div className="px-6 pb-6">
          <p className="text-onlight-text-2 dark:text-ondark-text-2 mb-4 text-sm">
            No longer want to use this Location for monitoring? You can delete
            the Location here.
          </p>
          <Button variant="error" onClick={() => setShowModal(true)}>
            Disable Location
          </Button>
        </div>
      </BasicPanel>

      <DeleteLocationModal
        open={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleDelete}
        isDeleting={deleteMutation.isLoading}
      />
    </>
  );
}

export default DeleteLocationCard;
